import { RetrievalMethod } from '@/feature/profiles/constants';
import { Retrievals } from './Retrievals';
import { Facesheets } from './Facesheets';
import { MedicationData } from './MedicationData';
import { HIE } from './HIE';
import { Uploads } from './Uploads';

export const REQUEST_ACTION_COMPONENTS: Record<
  RetrievalMethod,
  React.ComponentType
> = {
  [RetrievalMethod.PROVIDER_FACILITY]: Retrievals,
  [RetrievalMethod.HIE]: HIE,
  [RetrievalMethod.MEDICATIONS]: MedicationData,
  [RetrievalMethod.RECORD_UPLOAD]: Uploads,
  [RetrievalMethod.FACESHEETS]: Facesheets,
};

// Order: PROVIDER_FACILITY -> HIE -> MEDICATIONS -> RECORD_UPLOAD -> FACESHEETS
export const REQUEST_ACTION_ORDER = [
  RetrievalMethod.PROVIDER_FACILITY,
  RetrievalMethod.HIE,
  RetrievalMethod.MEDICATIONS,
  RetrievalMethod.RECORD_UPLOAD,
  RetrievalMethod.FACESHEETS,
] as const;

export const REQUEST_ACTION_ORDER_MAP: Record<RetrievalMethod, number> =
  REQUEST_ACTION_ORDER.reduce(
    (acc, method, index) => {
      acc[method] = index;
      return acc;
    },
    {} as Record<RetrievalMethod, number>,
  );
